module.exports = new __parcel__URL__("icons8-redux.1951d779.svg").toString();